import React, { FC, Suspense, useEffect, lazy } from 'react'
import { observer } from 'mobx-react'
import { parseSearch } from 'src/pc/store/cloudGame/utils'
import { setupSDK } from './setupSDK'
import CloudGamePagePostMessage from 'src/pc/CloudGame/cloudGamePagePostMessage'
import CloudGameHost from 'src/pc/CloudGame/CloudGameHost'
import CloudGamePlayer from 'src/pc/CloudGame/CloudGamePlayer'

type CloudPlatform = 'tencent' | 'ydw'

/** buildType 和 环境映射 */
const EnvMap = {
  dev: 'test',
  test: 'test',
  pre: 'prd',
  prod: 'prod',
}

/** url 查询参数 */
const query = parseSearch()

/** 是否是被邀请玩家 */
const isPlayer = query.role === 'player'
/** 第三方平台 */
const platform = (query.connectThirdCompany as CloudPlatform) || 'tencent'
/** 传给迷你端的环境参数 */
const env = EnvMap[process.env.BUILD_TYPE] || 'prod'

const PlatFormMap = {
  tencent: {
    install() {
      return setupSDK(['/tencentCloudSdk.js'])
    },
  },
  ydw: {
    install() {
      return setupSDK(['/tencentCloudSdk.js'])
    },
  },
}

async function installGameSDK(platForm: CloudPlatform) {
  return PlatFormMap[platForm] && PlatFormMap[platForm].install()
}

const CloudPageView = lazy(() =>
  installGameSDK(platform).then(() => ({ default: isPlayer ? CloudGamePlayer : CloudGameHost })),
)

const CloudGameRoot: FC = () => {
  const Loading: FC = () => {
    return <p style={{ color: '#fff' }}>loading</p>
  }
  /** onload */
  useEffect(() => {
    CloudGamePagePostMessage.post({ code: 'cloud_page_load_complete' })
  }, [])
  return (
    <Suspense fallback={<Loading />}>
      <CloudPageView env={env} query={query} />
    </Suspense>
  )
}

export default observer(CloudGameRoot)
